import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useNavigate } from 'react-router-dom';


const Header = () => {
    const navigate = useNavigate()
    const expand = 'md'

    return (
        <>
            <Navbar key={expand} expand={expand} className="bg-body-tertiary mb-3">
                <Container fluid>
                    <Navbar.Brand href="/">
                        <span hidden className='wlab-font'>ω lab</span>
                        <img src='./logo2.png' alt="" style={{height : '56px', marginTop: '-16px', marginBottom: '-16px'}} />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
                    <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-${expand}`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                        placement="end"
                        >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                            
                            <img src='./logo2.png' alt="" style={{height : '60px'}} />
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="justify-content-end flex-grow-1 pe-3">
                            <Nav.Link onClick={() => navigate("/")}>HOME</Nav.Link>
                            <Nav.Link onClick={() => navigate("/member/lin_wu")}>PI</Nav.Link>
                            <Nav.Link onClick={() => navigate("/members")}>MEMBERS</Nav.Link>
                            <Nav.Link onClick={() => navigate("/research")}>RESEARCH</Nav.Link>
                            <Nav.Link onClick={() => navigate("/gallery")}>GALLERY</Nav.Link>
                            <Nav.Link onClick={() => navigate("/joinus")}>JOIN US</Nav.Link>
                        </Nav>

                    </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
        </>
    )
}

export default Header;